import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCheck, faHandPointUp } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

// Api
import dashboard_api from "../../../api/dashboard_api"

//Context
import { useAuth } from '../../../context/auth';


//CSS
import "../../../assets/css/dashboard.css";

//Shared
import { showMessage } from '../../../helpers/message';
import { isSincronizacaoIndiceIPCAAtrasada } from '../../../helpers/indiceIPCA';
import indiceIPCA_api from '../../../api/indiceIPCA_api';


export default function Dashboard({ permissoes }) {
    //State para dashboards
    const [dashboard, setDashboard] = useState([]);

    //State exibir card informativo
    const [visibilidadeCardIndiceIPCA, setVisibilidadeCardIndiceIPCA] = useState(false);

    //State indica se já passou do dia limite de publicação do índice pelo IBGE
    const [sincronizacaoIndiceIPCAAtrasada, setSincronizacaoIndiceIPCAAtrasada] = useState(() => isSincronizacaoIndiceIPCAAtrasada());

    //State para pegar total de falhas
    const [listFalhaIntegracoes, setListFalhaIntegracoes] = useState([]);

    //Estado de controle de exibição dos valores dos cards
    const [showContent, setShowContent] = useState({});

    const { setLoading } = useAuth();

    //Estado de navegação
    const navigate = useNavigate();

    const onClick = (tipocard) => {
        setShowContent({
            ...showContent,
            [tipocard]: !showContent[tipocard]
        })
    }

    //Função para carregar dados da etapa
    function loadDashboard() {
        setDashboard([])
        setLoading(true);
        dashboard_api.GetDashboard()
            .then(response => {
                setDashboard(response.data);
                const _showContent = {};
                response.data?.tipoFiscalizacao?.map(value => {
                    _showContent[value.tipoFiscalizacao] = false
                })
                setShowContent(_showContent);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    };

    //Função para carregar dados da etapa
    function loadVerificacaoCadastroIndiceMesAtual() {
        setLoading(true);
        indiceIPCA_api.getVerificacaoCadastroIndiceMesAtual()
            .then(response => {
                setVisibilidadeCardIndiceIPCA(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    };

    function loadListIntegracaoFalha() {
        setLoading(true);
        dashboard_api.GetListIntegracaoFalha()
            .then(response => {
                setListFalhaIntegracoes(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        loadVerificacaoCadastroIndiceMesAtual();
        loadDashboard();
        loadListIntegracaoFalha();
    }, []);

    //Reavalia o dia limite periodicamente, para o alerta atualizar mesmo com o dashboard aberto de um dia para o outro
    useEffect(() => {
        const interval = setInterval(() => {
            setSincronizacaoIndiceIPCAAtrasada(isSincronizacaoIndiceIPCAAtrasada());
        }, 60 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div className="content">
                {visibilidadeCardIndiceIPCA &&
                    <Row className='mt-4'>
                        <Col
                            className='mb-2'
                            md={12}
                            lg={12}
                            style={{ cursor: "pointer" }}
                        >
                            <div
                                className='alert alert-danger'
                                onClick={() => {
                                    navigate("/admin/cadastros/indiceIPCA")
                                }}
                            >
                                {sincronizacaoIndiceIPCAAtrasada
                                    ? "Atenção: a sincronização automática do Índice IPCA com o IBGE pode estar falhando. Verifique ou cadastre manualmente."
                                    : "Atenção: Índice IPCA não cadastrado"}
                            </div>
                        </Col>
                    </Row>
                }

                {listFalhaIntegracoes.length > 0 &&
                    <Row className='mt-1'>
                        <Col
                            className='mb-2'
                            md={12}
                            lg={12}
                            style={{ cursor: "pointer" }}
                        >
                            <div className='alert alert-danger' >
                                Existem registros de integração que apresentaram falha na execução. Entre em contato com o suporte!
                            </div>
                        </Col>
                    </Row>
                }

                <Row>
                    {dashboard?.tipoFiscalizacao?.map((value, key1) => {
                        return (
                            <Col className='mb-2' md={12} lg={6} key={key1}>
                                <div className='shadow rounded overflow-hidden'>
                                    <h6
                                        onClick={() => onClick(value.tipoFiscalizacao)}
                                        role='button'
                                        className='titleDashboard text-white p-2 d-flex align-items-center justify-content-between mb-0'>
                                        {value.tipoFiscalizacao} <FontAwesomeIcon icon={showContent[value.tipoFiscalizacao] ? faAngleUp : faAngleDown} />
                                    </h6>
                                    <div className={`cardContainer ${showContent[value.tipoFiscalizacao] ? "" : "close"}`}>
                                        {
                                            value.etapas.map((etapa, key2) => {
                                                return (
                                                    <div
                                                        onClick={() => {
                                                            if (etapa.status === "Azul") {
                                                                showMessage("Aviso", "Etapa sem fiscalização!", "warning", null);
                                                                return;
                                                            }

                                                            navigate("/admin/listaInfracoes", {
                                                                state: {
                                                                    etapa: etapa.etapa,
                                                                    tipoFiscalizacao: value.tipoFiscalizacao,
                                                                    btnVoltar: "/admin/dashboard",
                                                                },
                                                            });
                                                        }}
                                                        role="button"
                                                        className="itemCard my-1 mx-2 d-flex align-items-center justify-content-between px-2 rounded"
                                                        key={key2}
                                                    >
                                                            <div className="flex-grow-1 d-flex align-items-center overflow-hidden">
                                                                <span className={`text-truncate ${etapa.voto}`}>{etapa.etapa}</span>
                                                                {etapa.voto && (
                                                                <FontAwesomeIcon icon={faHandPointUp} className="px-1 flex-shrink-0" />
                                                                )}
                                                            </div>
                                                        <div 
                                                            className="d-flex align-items-center gap-2 flex-shrink-0" 
                                                            style={{ whiteSpace: "nowrap" }}
                                                        >
                                                            {etapa.status === "Azul" ? (
                                                            <FontAwesomeIcon
                                                                className="text-primary"
                                                                icon={faCheck}
                                                                style={{ width: "10px" }}
                                                            />
                                                            ) : (
                                                            <div
                                                                className={`rounded-circle bg-${
                                                                etapa.status === "Verde"
                                                                    ? "success"
                                                                    : etapa.status === "Amarelo"
                                                                    ? "warning"
                                                                    : "danger"
                                                                }`}
                                                                style={{ width: "10px", height: "10px" }}
                                                            ></div>
                                                            )}
                                                            <div className="bg-light px-2 rounded border">{etapa?.quantidade ?? 0}</div>
                                                        </div>
                                                    </div>

                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                        )
                    })}
                </Row>
            </div >
        </>
    )
}